import { styled } from '@mui/material/styles';
import { ReactComponent as Procore } from 'assets/icons/procore.svg';
// import { ReactComponent as Autodesk } from 'assets/icons/autodesk.svg';
import { Box, Collapse, Button as MuiButton } from '@mui/material';
import Key2FillIcon from 'remixicon-react/Key2FillIcon';
import { VerifyUserDomainResponse } from 'hooks/useAuth';
import { useMemo } from 'react';
import { useProcoreAuth } from '../hooks/useProcoreAuth';

type RenderAuthOptionsProps = {
  verifyDomainResponse: VerifyUserDomainResponse | undefined;
};

function RenderAuthOptions({ verifyDomainResponse }: RenderAuthOptionsProps) {
  const {
    isLoading: isLoggingWithProcore,
    isProcoreLoading,
    continueWithProcore,
  } = useProcoreAuth();
  const isSSOEnabled = useMemo(
    () => verifyDomainResponse?.loginType.includes('SSO'),
    [verifyDomainResponse],
  );

  const continueWithSSO = () => {
    window.location.href = verifyDomainResponse?.redirectUrl || '';
  };

  return (
    <Box>
      <Button
        fullWidth
        onClick={continueWithProcore}
        variant="outlined"
        disabled={isProcoreLoading || isLoggingWithProcore}
        startIcon={<Procore />}
      >
        {isProcoreLoading && isLoggingWithProcore
          ? 'Logging In...'
          : isProcoreLoading
            ? 'Loading Procore...'
            : 'Continue with Procore'}
      </Button>
      {/* <Button fullWidth variant="outlined" startIcon={<Autodesk />} sx={{ mt: 1.5 }}>
        Continue with Autodesk
      </Button> */}
      <Collapse in={isSSOEnabled}>
        {isSSOEnabled && (
          <Button
            fullWidth
            onClick={continueWithSSO}
            variant="outlined"
            startIcon={<Key2FillIcon />}
            sx={{ mt: 1.5 }}
          >
            Continue with SSO
          </Button>
        )}
      </Collapse>
    </Box>
  );
}

const Button = styled(MuiButton, { label: 'Button' })(({ theme }) => ({
  borderColor: theme.palette.custom.geyser,
  borderRadius: 8,
  height: 56,
}));

export default RenderAuthOptions;
